<div class="quests-container">
  <!-- Header Section with Filters and Search -->
  <div class="quests-header">
    <div class="filters-section">
      <div class="filter-buttons">
        <button class="filter-btn" [class.active]="statusFilter === 'all'" (click)="filterByStatus('all')">
          All Quests
        </button>
        <button class="filter-btn" [class.active]="statusFilter === 'in-progress'"
          (click)="filterByStatus('in-progress')">
          In-Progress
        </button>
        <button class="filter-btn" [class.active]="statusFilter === 'completed'" (click)="filterByStatus('completed')">
          Completed
        </button>
      </div>
    </div>

    <div class="search-section">
      <input type="text" class="search-input" placeholder="Search Quests" [(ngModel)]="searchQuery"
        (input)="searchQuests()" />
      <span class="search-icon">🔍</span>
    </div>
  </div>

  <!-- Loading State -->
  <div class="loading-state" *ngIf="isLoading">
    <p>Loading quests data...</p>
  </div>

  <!-- Quests List -->
  <div class="quests-list" *ngIf="!isLoading && hasQuests()">
    <div *ngFor="let quest of filteredQuestsData; let i = index" class="quest-card"
      [class.expanded]="isQuestExpanded(i)">

      <!-- Quest Header (Collapsed View) -->
      <div class="quest-header" (click)="toggleQuestExpansion(i)">
        <div class="quest-header-content">
          <img [src]="quest.questThumbnail" alt="Quest thumbnail" class="quest-thumbnail">
          <div class="quest-info">
            <h3 class="quest-name">{{ quest.questName }}</h3>
            <p class="quest-description">{{ quest.questShortDescription }}</p>
          </div>
        </div>
        <div class="quest-meta">
          <div class="quest-status-line">
            <span class="quest-started-date">Started Date: {{ formatDate(quest.startDateTime) }}</span>
            <span class="quest-completed-date" *ngIf="quest.isCompleted && quest.completedDateTime">
              Completed On: {{ formatDate(quest.completedDateTime) }}
            </span>
            <span class="quest-status-badge" [class.status-completed]="getQuestStatus(quest) === 'Completed'"
              [class.status-in-progress]="getQuestStatus(quest) === 'In-Progress'">
              {{ getQuestStatus(quest) }}
            </span>
          </div>
          <mat-icon class="expand-icon">{{ isQuestExpanded(i) ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
            }}</mat-icon>
        </div>
      </div>

      <!-- Quest Body (Expanded View) -->
      <div class="quest-body" *ngIf="isQuestExpanded(i)">
        <!-- Sessions Grid (includes Introduction) -->
        <div class="sessions-grid">
          <!-- Introduction Card -->
          <div class="session-card introduction-card">
            <img [src]="quest.introduction.thumbnail" alt="Introduction" class="session-thumbnail">
            <div class="session-content">
              <h4 class="session-title">Introduction :</h4>
              <p class="session-description">{{ quest.introduction.description }}</p>
              <!-- <div class="session-footer">
                <span class="session-status-badge status-completed">Completed</span>
                <span class="session-completion-date">Completed on <strong>{{ formatDate(quest.startDateTime)
                    }}</strong></span>
              </div> -->
            </div>
          </div>

          <!-- Session Cards -->
          <div *ngFor="let session of quest.sessions; let sessionIndex = index" class="session-card">
            <img [src]="session.thumbnail" alt="Session thumbnail" class="session-thumbnail">
            <div class="session-content">
              <h4 class="session-title">Session {{ sessionIndex + 1}}:</h4>
              <p class="session-description">{{ session.shortDescription }}</p>
              <div class="session-footer">
                <span class="session-status-badge" [class.status-completed]="getSessionStatus(session) === 'Completed'"
                  [class.status-not-started]="getSessionStatus(session) === 'Not Started'">
                  {{ getSessionStatus(session) }}
                </span>
                <span class="session-completion-date">
                  <ng-container *ngIf="session.sessionCompletionDate">Completed on <strong>{{
                      formatDate(session.sessionCompletionDate) }}</strong></ng-container>
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Empty State -->
  <div class="empty-state" *ngIf="!isLoading && !hasQuests()">
    <p>No quests available.</p>
  </div>
</div>